﻿import { useEffect } from 'react';

import { StudentDetailsContext, StudentsContext } from 'pages/students/context/StudentsDefaultContext';
import { NotificationContextProvider, useNotification } from 'app/notifications';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { StudentGroup, StudentGroupApi } from 'apis/StudentGroupApi';
import { StudentDetail } from 'pages/students/StudentDetail';
import { StudentPermissions } from 'pages/students/types';
import { setCountriesWithUnitedStateAtTop } from 'utils';
import { Country, CountryApi } from 'apis/CountryApi';
import { TabsContextProvider } from 'components/Tabs';
import { useIntl } from 'react-intl';

// Tours temporarily disabled
// import { JoyrideContextProvider } from 'app/joyride';
import { Students } from 'pages/students/Students';
import { DefaultLayout } from 'components/layout';
import { useParams } from 'react-router-dom';
import { PermissionsApi } from 'apis';
import { useSuperState } from 'hooks';

export const StudentsWrapper = () => {

    const { formatMessage } = useIntl();
    const [state, setState] = useSuperState({
        countries: [] as Country[],
        groupsWindow: undefined as Window | undefined,
        loading: true,
        permissions: null as StudentPermissions,
        studentGroups: [] as StudentGroup[],
        transactionsWindow: undefined as Window | undefined
    });

    const { countries, groupsWindow, loading, permissions, studentGroups, transactionsWindow } = state;

    const { id } = useParams();

    const { catchWithToast } = useNotification();

    const fetchPermissions = async () => {

        try {

            const permissions = await PermissionsApi.Get('Student');
            setState({
                loading: false,
                permissions
            });

        } catch (e) {

            console.error(e);
            setState({ loading: false });

        }

    };

    const loadData = async () => {

        try {

            const countries = await CountryApi.GetAll();
            setState({ countries: setCountriesWithUnitedStateAtTop(countries) });

        } catch (e) {

            catchWithToast(formatMessage({ id: 'failed_to_load_countries.6efc8543', defaultMessage: 'Failed to load countries.' }))(e);

        }

        try {

            const studentGroups = await StudentGroupApi.GetAll('Partner');
            setState({ studentGroups });

        } catch (e) {

            catchWithToast(formatMessage({ id: 'failed_to_load_student_groups.366db13d', defaultMessage: 'Failed to load student groups.' }))(e);

        }

    };

    useEffect(() => {

        fetchPermissions();
        loadData();

    }, []);

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'students.c6d199ef', defaultMessage: 'Students', description: 'menu' })}>
            <StudentsContext.Provider
                value={{
                    countries,
                    groupsWindow,
                    permissions,
                    setGroupsWindow: groupsWindow => setState({ groupsWindow }),
                    setTransactionsWindow: transactionsWindow => setState({ transactionsWindow }),
                    studentGroups,
                    transactionsWindow
                }}
            >
                <TabsContextProvider disableUrlSync context={StudentDetailsContext}>
                    {/* Tours temporarily disabled */}
                    {/* <JoyrideContextProvider> */}
                    <NotificationContextProvider>
                        {loading ?
                            (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: 'calc(100vh - 70px)' }}>
                                    <GMetrixLoader />
                                </div>
                            )
                            :
                            (
                                id ? <StudentDetail /> : <Students />
                            )
                        }
                    </NotificationContextProvider>
                    {/* </JoyrideContextProvider> */}
                </TabsContextProvider>
            </StudentsContext.Provider>
        </DefaultLayout>
    );

};